<p>{{ createdByText() | translate }}</p>
